import api from './api.js';

export const ftp_db_config = async () => {
  try {
    const response = await api.post('/Configurar');  
 
    if (response.data.sucesso) {
      return response.data;
    } else {
      throw new Error('Falha ao carregar configuração.');
    }
  } catch (error) {
    console.error(error);
    console.error('Erro em config.js:', error.message);
    throw error;
  }
};
 